import axios from 'axios'
import lstModules from 'common/json/lstModules.json'

var httpURL = lstModules['recruitment'].url + ':' + lstModules['recruitment'].port;
var httpurl = lstModules['main'].url + ':' + lstModules['main'].port;
var tokenid = localStorage.getItem('tokenid');

function getPersonalDtlsSvc(cbPersonalDtlsResponse, tchId) {
    axios(
        {
            url: httpURL + "/sms/recruitment/tch/personal/dtls",
            method: "POST",
            withCredentials: true,
            params: { tchId: tchId },
            headers: { 'tokenid': tokenid }
        })
        .then((response) => {
            var result = {}
            result = response.data
            cbPersonalDtlsResponse(result)
        })
        .catch((error) => {
            // console.log("Personal Dtls is not getting called")
        });
}

function getLstStateSvc(cbLstStateResponse) {
    axios(
        {
            url: httpurl + "/sms/mst/state/list",
            method: 'POST',
            params: {},
            headers: { 'tokenid': tokenid },
            withCredentials: true
        }
    ).then(
        (Response) => {
            var data = {}
            data = Response.data.lstState
            cbLstStateResponse(data)
            // console.log(Response.data.SvcStatus)
        }
    ).catch((error) => {
        // console.log("State List Fetch error")
    });
}

function getLstCitySvc(cbLstCityResponse, stateId) {
    axios(
        {
            url: httpurl + "/sms/mst/city/list",
            method: 'POST',
            params: { stateId: stateId },
            headers: { 'tokenid': tokenid },
            withCredentials: true
        }
    ).then(
        (Response) => {
            var data = {}
            data = Response.data.lstCity
            cbLstCityResponse(data)
            // console.log(Response.data.SvcStatus)
        }
    ).catch((error) => {
        // console.log("City List Fetch error")
    });
}

function saveTchSvc(cbSaveTchResponse, personal) {
    axios(
        {
            url: httpURL + "/sms/recruitment/tch/personal/save",
            method: "POST",
            withCredentials: true,
            params: { personal: personal },
            headers: { 'tokenid': tokenid }

        })
        .then((Response) => {
            var result = {}
            result.status = Response.data.SvcStatus
            result.message = Response.data.SvcMsg
            cbSaveTchResponse(result)
        })
        .catch((error) => {
            console.error(error)
        });
}

export { getPersonalDtlsSvc, getLstStateSvc, getLstCitySvc, saveTchSvc }